import type { ItemDef } from "../../engine/rpg/Skills";

export const ITEMS: ItemDef[] = [
  {
    id: "herb",
    name: "Medicinal Herb",
    description: "Bitter, but it closes a wound.",
    price: 8,
    kind: "consumable",
    consumable: true,
    use: "mend",
  },
  {
    id: "elixir",
    name: "Elixir of Dawn",
    description: "Restores a fallen companion.",
    price: 60,
    kind: "consumable",
    consumable: true,
    use: "revive",
  },
  {
    id: "copper-sword",
    name: "Copper Sword",
    description: "Soft metal, sharp enough.",
    price: 40,
    kind: "weapon",
    attack: 6,
  },
  {
    id: "iron-blade",
    name: "Iron Blade",
    description: "Honest weight in the hand.",
    price: 140,
    kind: "weapon",
    attack: 13,
  },
  {
    id: "oak-staff",
    name: "Oak Staff",
    description: "Channels a spell nicely.",
    price: 35,
    kind: "weapon",
    attack: 4,
    agility: 2,
  },
  {
    id: "leather-vest",
    name: "Leather Vest",
    description: "Turns aside a claw or two.",
    price: 30,
    kind: "armor",
    defense: 5,
  },
  {
    id: "chain-mail",
    name: "Chain Mail",
    description: "Heavy, and worth every ounce.",
    price: 120,
    kind: "armor",
    defense: 11,
  },
  {
    id: "silk-robe",
    name: "Silk Robe",
    description: "Light enough to cast in.",
    price: 45,
    kind: "armor",
    defense: 6,
    maxHp: 4,
  },
];
